var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-tip"},[_c('span',{staticClass:"sp1"}),_c('span',{staticClass:"sp2",class:_vm.sign})])
}
var staticRenderFns = []

export { render, staticRenderFns }